/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import ListerMeta from '../ListerTools/ListerMeta'
import ProductList from '../../containers/ProductList/ProductList'
import Pagination from '../Pagination/Pagination'
import Feedback from '../Feedback/Feedback'
import ListerTools from '../../containers/ListerTools/ListerTools'
import GoogleDFPAds from '../GoogleDFPAds/GoogleDFPAds'
import GoogleAdSenseFooter from '../GoogleAdSenseFooter/GoogleAdSenseFooter'
import GoogleAdSense from '../../helpers/GoogleAdSense'
import SpellcheckBanner from '../SpellcheckBanner/SpellcheckBanner'
import config, { searchTypes } from '../../config'
import FilterPanel from '../../containers/FilterPanel/FilterPanel'
import ListerTitle from '../ListerTitle/ListerTitle'
import ProductListRelevancy from '../ProductList/ProductListRelevancy'
import { getContentAreas } from '../../helpers/ProductListerContentHelper'
import ContentHelper from '../../helpers/ContentHelper'
import BrandsNICBanner from '../BrandsNICBanner/BrandsNICBanner'
import ErrorPage from '../ErrorPage/ErrorPage'
import NoResultsSuggestions from '../../containers/NoResultsSuggestions/NoResultsSuggestions'
import * as Styled from './styles'

class Lister extends React.Component {
  categoryUnmatchCallback = () => {
    this.context.navigateTo(`${window.location.pathname}opt/catmatch:off/`)
  }

  hasProducts(products) {
    return products && (products[0]?.length > 0 || products[1]?.length > 0)
  }

  handleGoogleAdsense(props) {
    let mount
    const { pageType } = props
    if (GoogleAdSense.isPageTypeValid(pageType) && config.adSense[pageType].enabled) {
      mount = (
        <ErrorBoundary>
          <GoogleAdSenseFooter {...props} />
        </ErrorBoundary>
      )
    }
    return mount
  }

  render() {
    const { categoryAncestors } = this.props
    const {
      searchTerm,
      products,
      isCannedSearch,
      searchType,
      appliedSortBy,
      categoryId,
      meta,
      pageType,
      categoryName,
      results,
      noResultsModalVisible,
      spellcheckedSearch,
      inputSearchTerm,
      searchTermSuggestions,
      brandSuggestions,
      contentAreas,
      topLevelCategoryId,
      appliedFilters,
      appliedFilterUriFragments,
      seoArea,
      dfp,
      isPlp,
      isPlpPlus,
      isPlpPlusDescendant,
      categoryNameFromFilter,
      isClearance
    } = this.props

    const sortByValues = pageType === 'browse' ? config.browseSortByValues : config.searchSortByValues
    const noResults = results === 0 && !noResultsModalVisible
    const validBreadcrumb =
      categoryAncestors.length > 0 &&
      !meta.categoryMatch &&
      searchType !== searchTypes.brandsNIC &&
      searchType !== searchTypes.NRS
    const hasBrandSuggestions = !!brandSuggestions && brandSuggestions.length > 0

    const prodsList = [].concat(products[0], products[1])
    const enableCommunicatingRelevancy =
      pageType !== 'browse' &&
      appliedSortBy &&
      appliedSortBy.relevance === 'desc' &&
      (appliedFilters.length === 0 || meta.categoryMatch)
    const hasTwoRelevancyBuckets = products[0].length < 30 && products[1].length && products[0].length !== 0

    let banner
    if (hasBrandSuggestions && brandSuggestions.length > 1 && !isCannedSearch) {
      banner = (
        <BrandsNICBanner
          inputSearchTerm={inputSearchTerm}
          searchTerm={searchTerm}
          brandSuggestions={brandSuggestions}
          searchType={searchType}
        />
      )
    } else if (!(searchType !== searchTypes.NRS && meta.categoryMatch)) {
      banner = (
        <SpellcheckBanner
          didYouMeanSearch={searchType === searchTypes.didYouMean}
          spellcheckedSearch={spellcheckedSearch}
          inputSearchTerm={inputSearchTerm}
          searchTerm={searchTerm}
          searchTermSuggestions={searchTermSuggestions}
        />
      )
    }

    return (
      <ErrorBoundary>
        <div className='search'>
          {(noResults || !this.hasProducts(products)) && !searchTerm && <ErrorPage />}
          {(noResults || !this.hasProducts(products)) && searchTerm && <NoResultsSuggestions searchTerm={searchTerm} />}
          {this.hasProducts(products) && (
            <Styled.SearchContent className='xs-row xs-auto--negative lg-auto--none' withBreadcrumb={validBreadcrumb}>
              <ErrorBoundary>
                <FilterPanel
                  brandSuggestions={brandSuggestions}
                  hasBrandSuggestions={hasBrandSuggestions}
                  searchType={searchType}
                  categoryMatch={meta.categoryMatch}
                />
              </ErrorBoundary>
              <Styled.Container className='xs-12--none lg-9--none xs-stack'>
                {!noResults &&
                  (enableCommunicatingRelevancy ? (
                    <ErrorBoundary key={hasTwoRelevancyBuckets ? 'product-list-2' : 'product-list-1'}>
                      {products[0].length > 0 && (
                        <>
                          <ListerTitle
                            categoryMatch={meta.categoryMatch}
                            isCannedSearch={isCannedSearch}
                            inputSearchTerm={inputSearchTerm}
                            searchTerm={searchTerm}
                            categoryName={pageType === 'search' ? categoryNameFromFilter : categoryName}
                            hasBrandSuggestions={hasBrandSuggestions}
                            brandSuggestions={brandSuggestions}
                            spellcheckedSearch={spellcheckedSearch}
                            fallBackCategoryName={categoryName}
                            searchType={searchType}
                            categoryUnmatchCallback={this.categoryUnmatchCallback}
                            pageType={pageType}
                            enableCommunicatingRelevancy={enableCommunicatingRelevancy}
                          />
                          {!!banner && <ErrorBoundary>{banner}</ErrorBoundary>}
                          {!noResults &&
                            getContentAreas(
                              contentAreas,
                              topLevelCategoryId,
                              ContentHelper.onFindabilityClick.bind(this),
                              isPlp,
                              isPlpPlus,
                              isPlpPlusDescendant
                            )}
                          <ListerTools
                            appliedSortBy={appliedSortBy}
                            appliedFilters={appliedFilters}
                            currentPage={meta.currentPage}
                            pageSize={meta.pageSize}
                            totalData={meta.totalData}
                            totalPages={meta.totalPages}
                            categoryMatch={meta.categoryMatch}
                            sortByValues={sortByValues}
                            searchTerm={searchTerm}
                            products={products}
                          />
                          <ProductList
                            prodsList={products[0]}
                            relevancyList={1}
                            inputSearchTerm={inputSearchTerm}
                            currentPage={meta.currentPage}
                            pageSize={meta.pageSize}
                            totalPages={meta.totalPages}
                            totalData={meta.totalData}
                            pageType={pageType}
                            categoryAncestors={categoryAncestors}
                            categoryId={categoryId}
                            appliedFilters={appliedFilterUriFragments}
                            appliedSortBy={appliedSortBy}
                            showBetaCard
                          />
                        </>
                      )}
                      {products[1].length >= 1 && hasTwoRelevancyBuckets ? (
                        <ProductListRelevancy inputSearchTerm={inputSearchTerm} products={products} />
                      ) : (
                        products[1].length > 1 &&
                        hasTwoRelevancyBuckets === false && (
                          <>
                            <ProductListRelevancy inputSearchTerm={inputSearchTerm} products={products} />
                            <ListerTools
                              appliedSortBy={appliedSortBy}
                              appliedFilters={appliedFilters}
                              currentPage={meta.currentPage}
                              pageSize={meta.pageSize}
                              totalData={meta.totalData}
                              totalPages={meta.totalPages}
                              categoryMatch={meta.categoryMatch}
                              sortByValues={sortByValues}
                              searchTerm={searchTerm}
                              products={products}
                            />
                          </>
                        )
                      )}
                      <ProductList
                        prodsList={products[1]}
                        relevancyList={2}
                        relevancyRecallOffset={products[0].length}
                        inputSearchTerm={inputSearchTerm}
                        currentPage={meta.currentPage}
                        pageSize={meta.pageSize}
                        totalPages={meta.totalPages}
                        totalData={meta.totalData}
                        pageType={pageType}
                        categoryAncestors={categoryAncestors}
                        categoryId={categoryId}
                        appliedFilters={appliedFilterUriFragments}
                        appliedSortBy={appliedSortBy}
                        showBetaCard
                      />
                    </ErrorBoundary>
                  ) : (
                    <>
                      <ErrorBoundary>
                        <ErrorBoundary>
                          <ListerTitle
                            categoryMatch={meta.categoryMatch}
                            isCannedSearch={isCannedSearch}
                            inputSearchTerm={inputSearchTerm}
                            searchTerm={searchTerm}
                            categoryName={pageType === 'search' ? categoryNameFromFilter : categoryName}
                            hasBrandSuggestions={hasBrandSuggestions}
                            brandSuggestions={brandSuggestions}
                            spellcheckedSearch={spellcheckedSearch}
                            fallBackCategoryName={categoryName}
                            searchType={searchType}
                            categoryUnmatchCallback={this.categoryUnmatchCallback}
                            pageType={pageType}
                            enableCommunicatingRelevancy={enableCommunicatingRelevancy}
                          />
                          {!!banner && <ErrorBoundary>{banner}</ErrorBoundary>}
                          {!noResults &&
                            getContentAreas(
                              contentAreas,
                              topLevelCategoryId,
                              ContentHelper.onFindabilityClick.bind(this),
                              isPlp,
                              isPlpPlus,
                              isPlpPlusDescendant
                            )}
                        </ErrorBoundary>
                        <ListerTools
                          appliedSortBy={appliedSortBy}
                          appliedFilters={appliedFilters}
                          currentPage={meta.currentPage}
                          pageSize={meta.pageSize}
                          totalData={meta.totalData}
                          totalPages={meta.totalPages}
                          categoryMatch={meta.categoryMatch}
                          sortByValues={sortByValues}
                          searchTerm={searchTerm}
                        />
                      </ErrorBoundary>

                      <ErrorBoundary>
                        <ProductList
                          prodsList={prodsList}
                          pageType={pageType}
                          categoryAncestors={categoryAncestors}
                          categoryId={categoryId}
                          appliedFilters={appliedFilterUriFragments}
                          showBetaCard
                        />
                      </ErrorBoundary>
                    </>
                  ))}
                {!noResults && (
                  <>
                    <ErrorBoundary>
                      <Pagination
                        appliedFilterUriFragments={appliedFilterUriFragments.allFilters}
                        appliedSortBy={appliedSortBy}
                        searchTerm={
                          searchType === searchTypes.brandsNIC || searchType === searchTypes.NRS
                            ? inputSearchTerm
                            : searchTerm
                        }
                        searchType={searchType}
                        categoryId={categoryId}
                        currentPage={meta.currentPage}
                        totalPages={meta.totalPages}
                        categoryAncestors={categoryAncestors}
                        categoryName={categoryName}
                        categoryIsClearance={isClearance}
                        categoryMatch={meta.categoryMatch}
                      />
                    </ErrorBoundary>

                    {pageType !== 'browse' && !isCannedSearch && (
                      <ErrorBoundary>
                        <Feedback searchTerm={searchTerm} />
                      </ErrorBoundary>
                    )}
                  </>
                )}

                <ListerMeta />
              </Styled.Container>
            </Styled.SearchContent>
          )}

          {dfp && (
            <aside className='xs-row xs-auto--negative google__dfp'>
              <div className='xs-hidden lg-block lg-3' />
              <div className='xs-block xs-12 lg-9'>
                <ErrorBoundary>
                  <GoogleDFPAds position='bottom' channelId={dfp.channelId} taxonomy={dfp.taxonomy} />
                </ErrorBoundary>
              </div>
            </aside>
          )}

          {!this.props.isCannedSearch &&
            !noResults &&
            this.handleGoogleAdsense({
              pageType,
              searchTerm: inputSearchTerm || '',
              categoryName,
              noResults,
              meta,
              categoryAncestors,
              isClearance
            })}

          {!noResults && !searchTerm && (
            <Styled.PlpSeoText className='xs-row xs-auto--negative'>
              <div className='xs-hidden lg-block lg-3' />
              <div className='xs-block xs-12 lg-9'>{getContentAreas(seoArea)}</div>
            </Styled.PlpSeoText>
          )}
        </div>
      </ErrorBoundary>
    )
  }
}

Lister.defaultProps = {
  filters: [],
  searchTermSuggestions: [],
  brandSuggestions: [],
  categoryAncestors: [],
  contentAreas: [],
  appliedFilters: []
}

Lister.propTypes = {
  searchTerm: PropTypes.string,
  categoryId: PropTypes.number,
  results: PropTypes.number,
  products: PropTypes.array,
  filters: PropTypes.array,
  isCannedSearch: PropTypes.bool,
  appliedFilters: PropTypes.array,
  appliedSortBy: PropTypes.object,
  meta: PropTypes.object,
  success: PropTypes.bool,
  categoryName: PropTypes.string,
  categoryAncestors: PropTypes.array,
  appliedFilterUriFragments: PropTypes.object,
  failedService: PropTypes.string,
  isPopulated: PropTypes.bool,
  ratingFilterApplied: PropTypes.bool.isRequired,
  errorModalIsVisible: PropTypes.bool.isRequired,
  noResultsModalVisible: PropTypes.bool.isRequired,
  spellcheckedSearch: PropTypes.bool.isRequired,
  searchType: PropTypes.string,
  inputSearchTerm: PropTypes.string,
  searchTermSuggestions: PropTypes.array,
  brandSuggestions: PropTypes.array,
  pageType: PropTypes.string,
  seoArea: PropTypes.array,
  dfp: PropTypes.object,
  contentAreas: PropTypes.array
}

Lister.contextTypes = {
  navigateTo: PropTypes.func,
  loadingStart: PropTypes.func
}

export default Lister
